// extracted by mini-css-extract-plugin
export default {"bg":"BackgroundBottom_bg__-1+wa","light":"BackgroundBottom_light__9u2eS","dark":"BackgroundBottom_dark__raBar"};